import { Injectable } from '@angular/core';
import {
	Alert,
	Attachment,
	ChangeOfferSelected,
	Conversation,
	ConversationMessages,
	Location,
	Offer,
	OfferChangeDialog,
	OfferChangeService,
	FrontendOfferService,
	OfferTerm,
	Organization,
	OwnerOrganizationAddress,
	Payment,
	PaymentsTerm,
	Reservation,
	Seller,
	Service,
	Slot,
	UserContact,
	UserData,
} from '@/reservation/reservation.model';
import { AddressKind } from './enums/AddressKind';
import { ContactDestiny } from './enums/ContactDestiny';
import { Status } from './enums/Status';
import { PaymentKindId } from './enums/PaymentKind';
import { OrganizationModel } from '@/organization/oranization.model';
import { BannerModel } from '@/www/www-banner/www-banner.component';
import { OfferChangeTypes } from '@/common/enums/OfferChangeType';
import { ServiceCountingMethods, ServiceDependsOn } from '@/services/service.model';
import { ContactDataInterface } from '@/organization/organization/organization.model';
import { BagTransportTerm, TermTourismEventSetKinds } from '@/bag/bag-transport-term/bag-transport-term.model';
import { LocationKinds } from '@/common/enums/LocationKinds';
import { SlotKind } from '@/common/enums/SlotKind';
import { BankAccount } from '@/organization/organization/organization-bank-accounts/organization-bank-accounts.model';
import { OfferTransportList } from '@/new-transport/_models/transport-list.model';

@Injectable({
	providedIn: 'root',
})
export class TypeValueFactoryService {
	static createReservationObject(): Reservation {
		return {
			accessToken: '',
			invoiceNumber: '',
			alerts: [],
			invoice: false,
			nightsStay: 1,
			days: 1,
			valueOfComponentsToCancel: 0,
			isOnRequest: false,
			costToCancel: 0,
			multimedias: [],
			canceledAt: '',
			balance: 0,
			balanceWithoutCommission: 0,
			cancellationCost: 0,
			feeDueToCancellation: 0,
			channel: '',
			commissionValue: 0,
			confirmationTime: '',
			currency: { code: '', exchangeRatePln: 0, id: 0, name: '' },
			expirationTime: '',
			id: 0,
			istourNumber: 0,
			offer: [],
			organization: {
				id: 0,
				name: '',
				shortName: '',
				isOskar: false,
			},
			ownerNip: '',
			ownerOrganization: {
				address: [],
				travelOrganizationGovernmentApproval: '',
				balance: 0,
				departments: [],
				id: 0,
				isOskar: false,
				krs: '',
				name: '',
				nawigatorID: 0,
				nip: '',
				regon: '',
				sellCategory: 0,
				shortName: '',
			},
			ownerUser: TypeValueFactoryService.createUserDataObject(),
			reservationTime: '',
			responsibleUser: { email: '', firstName: '', id: 0, lastName: '' },
			seller: {
				travelOrganizationGovernmentApproval: '',
				address: [],
				balance: 0,
				departments: [],
				id: 0,
				isOskar: false,
				krs: '',
				name: 'Brak',
				nawigatorID: 0,
				nip: '',
				regon: '',
				sellCategory: 0,
				shortName: '',
			},
			sellerCategory: { fee: 0, id: 0, name: '', use: false },
			services: [],
			status: Status.OPTION,
			time: { lower: '', upper: '' },
			totalPrice: 0,
			voucher: null,
		};
	}

	static createOfferWithSlotObject(): Offer {
		return {
			surchargeCurrency: 0,
			surchargeFee: 0,
			offerChangeService: 13,
			wasTransportAvailable: true,
			costToCancel: 0,
			board: {
				board: 0,
				boardPrice: 0,
				code: '',
				currency: '',
				id: 0,
				name: '',
				priceSetting: {
					mainBoard: { id: 0, name: '' },
					mainPrice: 0,
					services: [],
				},
			},
			cancellationCost: 0,
			cancellationPercentage: 0,
			commissionValue: 0,
			daysBeforeDeparture: 0,
			id: 0,
			oskarFault: false,
			product: {
				organization: {
					id: 0,
					name: '',
					shortName: '',
					isOskar: false,
				},
				code: '',
				conveniences: [],
				id: 0,
				location: [],
				name: '',
				productKind: {
					id: 0,
					name: '',
					code: '',
				},
				insurer: null,
			},
			promotion: [],
			roomAvailabilityState: {
				comment: '',
				dateRange: { lower: '', upper: '' },
				id: 0,
				room: 0,
				state: '',
			},
			roomType: {
				code: '',
				configuration: [],
				id: 0,
				kind: '',
				name: '',
			},
			services: [],
			slot: [
				{
					cancellationCost: 0,
					catalogPrice: 0,
					costToCancel: 0,
					id: 0,
					kind: SlotKind.ADULT,
					feeDueToCancellation: 0,
					price: 0,
					priceBoard: 0,
					days: 0,
					priceTransportDeparture: 0,
					priceTransportReturn: 0,
					priceWithoutPromotion: 0,
					promotionValue: 0,
					slotServices: [],
					status: '',
					stopDeparture: {
						fee: 0,
						id: 0,
						stop: {
							address: '',
							amount: 0,
							amountFree: 0,
							departureDatetime: '',
							fee: 0,
							id: 0,
							kind: '',
							location: {
								code: '',
								id: 0,
								kind: '',
								locationKind: LocationKinds.REGION,
								name: '',
								parentLocation: null,
							},
							name: '',
							parentStop: null,
							returnDatetime: '',
							stop: 0,
							stopType: '',
							transport: undefined,
						},
						timeDeparture: '',
						transport: 0,
					},
					stopReturn: {
						fee: 0,
						id: 0,
						stop: {
							address: '',
							amount: 0,
							amountFree: 0,
							departureDatetime: '',
							fee: 0,
							id: 0,
							kind: '',
							location: {
								code: '',
								id: 0,
								kind: '',
								locationKind: LocationKinds.REGION,
								name: '',
								parentLocation: null,
							},
							name: '',
							parentStop: null,
							returnDatetime: '',
							stop: 0,
							stopType: '',
							transport: null,
						},
						timeDeparture: '',
						transport: 0,
					},
					totalPrice: 0,
					transportDeparture: 0,
					transportReturn: 0,
					userData: TypeValueFactoryService.createUserDataObject(),
					deliveryStatus: null,
				},
			],
			status: '',
			term: {
				dateRange: { lower: '', upper: '', bounds: '' },
				gratis: 0,
				id: 0,
				nightsStay: 0,
			},
			totalPrice: 0,
			totalPriceWithoutPromotion: 0,
			transportKind: '',
			additionalRoomSizeCharge: 0,
			insurance: null,
			insurer: null,
		};
	}

	static createActiveAlertObject(): Alert {
		return {
			active: true,
			alert: {
				active: false,
				id: '',
				name: '',
				organizationDepartments: [],
			},
			id: '',
			lastModified: '',
			modifiedBy: null,
			reservation: 0,
			reservationOffer: 0,
			reservationSlot: 0,
		};
	}

	static createNonActiveAlertObject(): Alert {
		return {
			active: false,
			alert: {
				active: false,
				id: '',
				name: '',
				organizationDepartments: [],
			},
			id: '',
			lastModified: '',
			modifiedBy: null,
			reservation: 0,
			reservationOffer: 0,
			reservationSlot: 0,
		};
	}

	static createUserDataObject(): UserData {
		return {
			birth: '',
			blackList: false,
			city: '',
			firstName: '',
			googleId: '',
			id: 0,
			idNumber: '',
			lastName: '',
			regularCustomer: false,
			nationality: {
				id: 0,
				name: '',
			},
			passportNumber: '',
			sex: '',
			shirtSize: '',
			user: 0,
			userAddresses: [],
			userConsent: [],
			userContacts: [],
			userDocuments: [],
		};
	}

	static createUserContactObject(): UserContact {
		return {
			destiny: {
				destiny: '',
				id: ContactDestiny.CONTACT,
			},
			email: '',
			id: 0,
			phone: '',
		};
	}

	static createSlotObject(): Slot {
		return {
			cancellationCost: 0,
			catalogPrice: 0,
			costToCancel: 0,
			id: 0,
			kind: SlotKind.ADULT,
			days: 0,
			feeDueToCancellation: 0,
			price: 0,
			priceBoard: 0,
			priceTransportDeparture: 0,
			priceTransportReturn: 0,
			priceWithoutPromotion: 0,
			promotionValue: 0,
			slotServices: [],
			status: '',
			stopDeparture: {
				fee: 0,
				id: 0,
				stop: {
					address: '',
					amount: 0,
					amountFree: 0,
					departureDatetime: '',
					fee: 0,
					id: 0,
					kind: '',
					location: {
						code: '',
						id: 0,
						kind: '',
						locationKind: LocationKinds.REGION,
						name: '',
						parentLocation: null,
					},
					name: '',
					parentStop: null,
					returnDatetime: '',
					stop: 0,
					stopType: '',
					transport: undefined,
				},
				timeDeparture: '',
				transport: 0,
			},
			stopReturn: {
				fee: 0,
				id: 0,
				stop: {
					address: '',
					amount: 0,
					amountFree: 0,
					departureDatetime: '',
					fee: 0,
					id: 0,
					kind: '',
					location: {
						code: '',
						id: 0,
						kind: '',
						locationKind: LocationKinds.COUNTRY,
						name: '',
						parentLocation: null,
					},
					name: '',
					parentStop: null,
					returnDatetime: '',
					stop: 0,
					stopType: '',
					transport: null,
				},
				timeDeparture: '',
				transport: 0,
			},
			totalPrice: 0,
			preCancellationPriceSummary: null,
			transportDeparture: 0,
			transportReturn: 0,
			userData: {
				birth: '',
				blackList: false,
				city: '',
				firstName: '',
				regularCustomer: false,
				googleId: '',
				id: 0,
				idNumber: '',
				lastName: '',
				nationality: {
					id: 0,
					name: '',
				},
				passportNumber: '',
				sex: '',
				shirtSize: '',
				user: 0,
				userAddresses: [],
				userConsent: [],
				userContacts: [],
				userDocuments: [],
			},
			deliveryStatus: null,
		};
	}

	static createTransportTermObject(): BagTransportTerm {
		return {
			files: [],
			id: 904,
			color: '',
			responsibleUser: null,
			departureTime: '',
			departureTimeDay: 'środa',
			maxSeatOptionalDeparture: 0,
			maxSeatOptionalReturn: 0,
			returnTimeDay: 'piątek',
			sumOfTransport: null,
			termtourismeventSet: [],
			insurers: [],
			peopleWithFaculties: 0,
			notesCount: 0,
			transportStop: {
				id: 854,
				parentStop: null,
				location: 3,
				address: '3 Stolice Północne',
				stopType: 'TG',
				erpGrid: null,
				longitude: null,
				latitude: null,
			},
			name: '3 Stolice Północne',
			accommodation: {
				lower: '2023-07-20',
				upper: '2023-07-22',
				lowerDay: '',
				upperDay: '',
				bounds: '[]',
			},
			returnTime: '2023-07-23T12:40:00Z',
			status: 50,
			offerTerm: [6130],
			departureMaxPlaces: 0,
			returnMaxPlaces: 0,
			swinging: false,
			actionTerm: false,
			transportDeparture: { id: 1671, kind: 'OF', linkedTransport: null },
			transportReturn: { id: 1679, kind: 'OF', linkedTransport: null },
			stopSale: false,
			markAsPopular: false,
			touristGuides: ['Jan Kowalski', 'Andrzej Kowalski'],
			reservations: {
				departureReservationCount: 0,
				departureReservationCountOptional: 0,
				departureConfirm: 0,
				returnReservationCount: 0,
				returnReservationCountOptional: 0,
				returnConfirm: 0,
			},
			slots: {
				departureSlotsCount: 0,
				departureSlotsCountOptional: 0,
				departureConfirm: 0,
				returnSlotsCount: 0,
				returnSlotsCountOptional: 0,
				returnConfirm: 0,
			},
			products: [1],
		};
	}

	static createOwnerOrganizationObject(): Organization {
		return {
			address: [],
			balance: 0,
			departments: [],
			id: 0,
			isOskar: false,
			krs: '',
			name: '',
			nawigatorID: 0,
			nip: '',
			regon: '',
			sellCategory: 0,
			shortName: '',
			travelOrganizationGovernmentApproval: '',
		};
	}

	static createOwnerOrganizationAddressObject(): OwnerOrganizationAddress {
		return {
			id: 12,
			address: 'Obornicka 85',
			kind: { id: AddressKind.HEADQUATERS, kind: '' },
			zipCode: '61-138',
			location: {
				code: '',
				id: 14,
				locationKind: 'CT',
				name: 'Poznań',
			},
		};
	}

	static createLocationWithRegionKindAndParentLocation(): Location {
		return {
			code: '',
			id: 2,
			kind: '',
			locationKind: LocationKinds.REGION,
			name: 'Poznań',
			parentLocation: {
				code: '',
				id: 3,
				kind: '',
				locationKind: LocationKinds.COUNTRY,
				name: 'Polska',
				parentLocation: undefined,
			},
		};
	}

	static createServiceObject(): Service {
		return {
			code: '',
			count: '',
			overwrittenPrice: null,
			countingMethod: '',
			description: '',
			id: 0,
			isActive: false,
			kinds: [],
			method: '',
			methodValue: 0,
			optionName: '',
			price: 0,
			service: {
				id: 0,
				name: '',
				code: '',
				countingMethod: ServiceCountingMethods.VALUE,
				serviceType: { id: 0, name: '' },
				isActive: false,
				methodValue: 0,
				dependsOn: ServiceDependsOn.SLOT,
				description: '',
				insurer: null,
			},
			value: 0,
			currency: null,
		};
	}

	static createPaymentObject(): Payment {
		return {
			amount: 0,
			bankAccountIncoming: '',
			bankAccountPosting: 0,
			currency: 0,
			date: '',
			id: 0,
			invoiceNumber: '',
			kind: {
				id: PaymentKindId.CASH,
				description: '',
			},
			note: '',
			organization: 0,
			payment: undefined,
			percentage: '',
			posting: undefined,
			status: '',
			userData: TypeValueFactoryService.createUserDataObject(),
			value: 0,
		};
	}

	static createPaymentTermObject(): PaymentsTerm {
		return {
			countKind: undefined,
			countValue: 0,
			currency: 0,
			id: 0,
			status: '',
			term: '',
			value: 0,
			createdBy: null,
			modifiedBy: null,
		};
	}

	static createMessageObject(): ConversationMessages {
		return {
			addressee: 'name@oskar.com.pl',
			attachmentCount: 0,
			body: 'dGVzdGluZyBjb250ZW50',
			date: '2023-07-10T10:31:26Z',
			details: false,
			id: '1893f5b29ca87c8c',
			labels: [],
			sender: 'BOK <bok-dev@oskar.com.pl>',
			show: false,
			subject: 'testing subject',
		};
	}

	static createAttachmentObjectWithImageMimeType(): Attachment {
		return {
			filename: 'exampleFileName.jpg',
			id: 'ANGjdJ_aVD19NuJeFKsYdELh3NjbksBROPPjgIQPmpGfCogA8XuRlvsc3yihhUBE2wC9JPe-QM2VED1eTM2vKz0ONQ7_xxG9Kcp',
			mimeType: 'image/jpg',
			size: 4228,
			src: '',
		};
	}

	static createAttachmentObjectWithTextHTMLMimeType(): Attachment {
		return {
			filename: 'exampleFileName.html',
			id: 'ANGjdJ_aVD19NuJeFKsYdELh3NjbksBROPPjgIQPmpGfCogA8XuRlvsc3yihhUBE2wC9JPe-QM2VED1eTM2vKz0ONQ7_xxG9Kcp',
			mimeType: 'text/html',
			size: 3251,
			src: '',
		};
	}

	static createAttachmentObjectWithZipMimeType(): Attachment {
		return {
			filename: 'exampleFileName.zip',
			id: 'ANGjdJ_aVD19NuJeFKsYdELh3NjbksBROPPjgIQPmpGfCogA8XuRlvsc3yihhUBE2wC9JPe-QM2VED1eTM2vKz0ONQ7_xxG9Kcp',
			mimeType: 'application/zip',
			size: 129415,
			src: '',
		};
	}

	static createAttachmentObjectWithPdfMimeType(): Attachment {
		return {
			filename: 'exampleFileName.pdf',
			id: 'ANGjdJ_aVD19NuJeFKsYdELh3NjbksBROPPjgIQPmpGfCogA8XuRlvsc3yihhUBE2wC9JPe-QM2VED1eTM2vKz0ONQ7_xxG9Kcp',
			mimeType: 'application/pdf',
			size: 129415,
			src: '',
		};
	}

	static createAttachmentObjectWithNotSupportedMimeType(): Attachment {
		return {
			filename: 'exampleFileName.docx',
			id: 'ANGjdJ_aVD19NuJeFKsYdELh3NjbksBROPPjgIQPmpGfCogA8XuRlvsc3yihhUBE2wC9JPe-QM2VED1eTM2vKz0ONQ7_xxG9Kcp',
			mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
			size: 279860,
			src: '',
		};
	}

	static createSellerObject(): Seller {
		return {
			address: [],
			balance: null,
			departments: [],
			id: 99,
			isOskar: true,
			krs: null,
			name: 'PRZEDSIĘBIORSTWO TRANSPORTOWO - USŁUGOWE "OSKAR - TRANS" SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ',
			nawigatorID: null,
			nip: '7781461394',
			regon: '301012668',
			shortName: 'PTUOT',
			travelOrganizationGovernmentApproval: '',
		};
	}

	static createConversationThreadObject(): Conversation {
		return {
			replied: false,
			tableId: 0,
			tableName: '',
			date: '2023-11-02T16:04:08Z',
			id: '18b90c7127cbecce',
			labels: [],
			subject: 'Test',
			unread: 0,
			watching: false,
		};
	}

	static createOfferTransportListObject(): OfferTransportList {
		return {
			notes: null,
			id: 0,
			insurerName: '',
			board: undefined,
			product: {
				code: '',
				id: 0,
				location: undefined,
				stop: null,
				defaultInsurance: null,
				name: '',
				productKind: undefined,
				surchargeProgram: undefined,
				insurer: null,
				insurance: null,
			},
			reservation: {
				id: 1897,
				ownerUser: undefined,
				status: undefined,
			},
			reservationSlotCount: 0,
			surchargeFee: 0,
			surchargeCurrency: null,
			slot: {
				cancellationCost: 0,
				catalogPrice: 0,
				costToCancel: 0,
				days: 0,
				feeDueToCancellation: 0,
				id: 0,
				kind: SlotKind.ADULT,
				price: 0,
				priceBoard: 0,
				priceTransportDeparture: 0,
				priceTransportReturn: 0,
				priceWithoutPromotion: 0,
				promotionValue: 0,
				seatnumber: undefined,
				slotServices: [],
				status: '',
				stopDeparture: undefined,
				stopReturn: undefined,
				totalPrice: 0,
				transportDeparture: 0,
				transportReturn: 0,
				userData: {
					birth: '',
					blackList: false,
					city: '',
					firstName: 'Łukasz',
					googleId: '',
					id: 0,
					idNumber: '',
					lastName: 'Kowalski',
					nationality: undefined,
					passportNumber: '',
					regularCustomer: false,
					sex: '',
					shirtSize: '',
					user: 0,
					userAddresses: [],
					userConsent: [],
					userContacts: [],
				},
				deliveryStatus: null,
			},
		};
	}

	static createOrganizationBackAccountObject(): BankAccount {
		return {
			currency: {
				id: 2,
				name: 'Polski',
				code: 'PLN',
				exchangeRatePln: 100,
			},
			shortName: 'example organization name',
			id: 1,
			kind: 3,
			isActive: true,
			mainAccount: false,
			number: '27109024028682888222459277',
			swift: '',
			organization: 17,
		};
	}

	static createOrganizationObject(): OrganizationModel {
		return {
			address: [
				{
					id: 1,
					location: {
						id: 2,
						name: 'Siedziba',
						code: 'HQ',
						location_kind: 'HQ',
						parent_location: 'HQ',
					},
					kind: 'HQ',
					zip_code: '61-234',
					address: 'Poznań, Obornicka 2',
				},
			],
			agencyMerlinx: null,
			balance: null,
			codeMerlinx: '',
			departments: [
				{
					id: 2,
					kind: 2,
					user_responsibility: 4,
					department_contacts: [
						{
							id: 5,
							phone: '123123123',
							email: 'test@test.pl',
						},
					],
				},
			],
			id: 17,
			isOskar: false,
			kindCooperation: null,
			krs: null,
			name: 'LIN',
			nawigatorID: null,
			nip: '111111111',
			regon: '3343434',
			sellCategory: null,
			shortName: 'linkoln',
			travelOrganizationGovernmentApproval: '',
		};
	}

	static createEnterpriseObject(): any {
		return {
			addressKind: [],
			locations: [],
			organizationRoles: [],
			organizationDepartments: [],
			sellCategory: [],
			accountKind: [],
			bankAccounts: [
				{
					currency: 1,
					id: '1',
					iban: '',
					kind: 3,
					isActive: true,
					mainAccount: true,
					number: '123123123123235425',
					swift: '',
					organization: 17,
				},
				{
					currency: 1,
					id: '2',
					iban: '',
					kind: 2,
					isActive: true,
					mainAccount: false,
					number: '4354564564566',
					swift: '',
					organization: 17,
				},
			],
			currency: [],
			departmentKinds: [],
			users: [],
			departmentsForUsers: [],
			departmentUsers: [],
			mainAccount: [
				{
					currency: 1,
					id: '1',
					iban: '',
					kind: 3,
					isActive: true,
					mainAccount: true,
					number: '123123123123235425',
					swift: '',
					organization: 17,
				},
			],
		};
	}

	static createWWWBannerObject(): BannerModel {
		return {
			name: 'banner',
			link: 'link.com',
			text: 'banner description',
			isActive: false,
			multimedia: '',
			multimediaMobile: '',
		};
	}

	static createOfferChangeCurrentOfferObject(): OfferChangeDialog {
		return {
			surchargeCurrency: 0,
			surchargeFee: 0,
			offerChangeService: 13,
			wasTransportAvailable: true,
			additionalRoomSizeCharge: 0,
			board: undefined,
			cancellationCost: 0,
			cancellationPercentage: 0,
			commissionValue: 0,
			costToCancel: 0,
			daysBeforeDeparture: 0,
			id: 0,
			newTotalPrice: 0,
			product: undefined,
			promotion: [],
			roomAvailabilityState: undefined,
			roomType: undefined,
			services: [],
			selectedService: undefined,
			slot: [
				{
					active: true,
					cancellationCost: 0,
					catalogPrice: 1000,
					costToCancel: 0,
					days: 2,
					feeDueToCancellation: 0,
					id: 0,
					kind: SlotKind.ADULT,
					newBoardPrice: 200,
					newRoomTypePrice: 0,
					newPrice: 1100,
					newTotalPrice: 1550,
					price: 0,
					priceAdjustment: 0,
					priceBoard: 200,
					priceTransportDeparture: 100,
					priceTransportReturn: 100,
					priceWithoutPromotion: 0,
					promotionValue: 100,
					seatnumber: undefined,
					selectedService: undefined,
					selectedStopDeparture: {
						address: '',
						fees: {
							departure: 100,
							return: 100,
						},
						name: 'Poznań',
						stop: 3,
						transport: { departureId: 0, returnId: 0 },
					},
					selectedStopReturn: {
						address: '',
						fees: {
							departure: 250,
							return: 250,
						},
						name: 'Kraków',
						stop: 15,
						transport: { departureId: 0, returnId: 0 },
					},
					servicesToAdd: [this.createKDROfferServiceObject(), this.createInsuranceOfferServiceObject()],
					slotServices: [this.createOfferChangeServiceObject()],
					status: '',
					stopDeparture: undefined,
					stopReturn: undefined,
					totalPrice: 0,
					transportDeparture: 0,
					transportReturn: 0,
					userData: undefined,
					deliveryStatus: null,
				},
			],
			status: Status.CONFIRMED,
			term: { id: 0 } as OfferTerm,
			totalPrice: 0,
			totalPriceWithoutPromotion: 0,
			transportKind: '',
			type: OfferChangeTypes.CONFIG,
			insurance: null,
			insurer: null,
		};
	}

	static createChangeOfferSelectedOfferObject(): ChangeOfferSelected {
		return {
			wasTransportAvailable: true,
			board: { additionalRoomSizeCharge: 0, id: 0, name: '', price: 0 },
			catalogPrice: 1000,
			dateRange: {
				lower: '2023-09-12',
				upper: '2023-09-15',
				bounds: '[]',
			},
			fee: 0,
			fullPrice: 900,
			nightsStay: 0,
			participants: { adults: 0, children: 0 },
			product: {
				code: '',
				conveniences: [],
				descriptions: [],
				id: 130,
				locations: [],
				multimedias: [],
				name: '',
				organization: 0,
				productKind: { id: 3, name: 'Wypoczynek' },
				surchargeBoard: undefined,
				surchargeProgram: undefined,
				tags: [],
				insurance: null,
				insurer: null,
				defaultInsurance: null,
			},
			promotion: undefined,
			promotionCatalog: 0,
			promotionValue: 0,
			roomType: { id: 0, name: '' },
			stop: {
				id: 0,
				name: '',
				transportDeparture: 1370,
				transportReturn: 1376,
			},
			term: 0,
			transportKind: '',
			surchargeCurrency: null,
			surchargeFee: 0,
			surchargeForExtraRoomSpace: 0,
			insurer: 0,
			insurance: null,
		};
	}

	static createOfferServiceObject(): FrontendOfferService {
		return {
			code: '',
			count: '',
			countingMethod: ServiceCountingMethods.PERMILLE,
			departures: undefined,
			dependsOn: ServiceDependsOn.SLOT,
			description: '',
			id: 98,
			importance: 0,
			isActive: false,
			kinds: [],
			method: '',
			methodValue: 0,
			name: '',
			serviceMultimedias: [],
			serviceType: undefined,
			use: '',
			insurer: null,
		};
	}

	static createKDROfferServiceObject(): FrontendOfferService {
		return {
			code: 'KDR-5%',
			count: '',
			countingMethod: ServiceCountingMethods.PERMILLE,
			departures: undefined,
			dependsOn: ServiceDependsOn.SLOT,
			description: '',
			id: 18,
			importance: 0,
			isActive: true,
			kinds: [],
			method: '',
			methodValue: -500,
			name: 'Karta Dużej Rodziny -5%',
			serviceMultimedias: [],
			serviceType: { id: 8, name: 'Zniżki' },
			use: '',
			insurer: null,
		};
	}

	static createInsuranceOfferServiceObject(): FrontendOfferService {
		return {
			code: 'UBEZROZ',
			count: '',
			countingMethod: ServiceCountingMethods.VALUE,
			departures: undefined,
			dependsOn: ServiceDependsOn.DAY,
			description: '',
			id: 4,
			importance: 0,
			isActive: true,
			kinds: [],
			method: '',
			methodValue: 40,
			name: 'Ubezpieczenie rozszerzone 4 PLN/os. za dzień',
			serviceMultimedias: [],
			serviceType: { id: 1, name: 'Ubezpieczenie kosztów leczenia' },
			use: '',
			insurer: null,
		};
	}

	static createOfferChangeServiceObject(): OfferChangeService {
		return {
			active: true,
			code: '',
			count: '',
			overwrittenPrice: null,
			countingMethod: ServiceCountingMethods.VALUE,
			description: '',
			id: 4,
			isActive: true,
			kinds: [],
			method: '',
			methodValue: 0,
			newPrice: 0,
			optionName: '',
			price: 0,
			service: {
				id: 4,
				countingMethod: ServiceCountingMethods.VALUE,
				name: 'Ubezpieczenie rozszerzone 4 PLN/os. za dzień',
				code: 'UBEZROZ',
				serviceType: { id: 3, name: 'Ubezpieczenia' },
				isActive: true,
				methodValue: 0,
				dependsOn: ServiceDependsOn.SLOT,
				description: '',
				insurer: null,
			},
			value: 0,
			currency: null,
		};
	}

	static createContactDataObject(): ContactDataInterface {
		return {
			id: 123,
			kind: {
				id: 123123,
				name: 'Dział prawny',
			},
			userResponsibility: {
				id: null,
				firstName: '',
				lastName: '',
				email: '',
			},
			departmentContacts: [{ id: 1, phone: '567567876', email: 'dzial.organizacji@it.pl' }],
		};
	}

	static createBagTransportTerm(): BagTransportTerm {
		return {
			files: [],
			accommodation: {
				lower: '2024-02-21',
				lowerDay: 'Środa',
				upper: '2024-02-21',
				upperDay: 'Środa',
				bounds: '[]',
			},
			actionTerm: true,
			color: 'red',
			departureMaxPlaces: 0,
			departureTime: '2024-02-20',
			departureTimeDay: 'Wtorek',
			id: 1201,
			maxSeatOptionalDeparture: null,
			maxSeatOptionalReturn: null,
			responsibleUser: null,
			name: 'Piękne Tatry',
			offerTerm: [85412],
			products: [340],
			reservations: {
				departureReservationCount: 8,
				departureReservationCountOptional: 1,
				returnReservationCount: 8,
				returnReservationCountOptional: 1,
				returnConfirm: 7,
				departureConfirm: 7,
			},
			insurers: [],
			returnMaxPlaces: 0,
			peopleWithFaculties: 0,
			notesCount: 0,
			returnTime: '2024-02-22',
			returnTimeDay: 'Czwartek',
			slots: {
				departureSlotsCount: 16,
				departureConfirm: 14,
				departureSlotsCountOptional: 2,
				returnSlotsCount: 16,
				returnConfirm: 14,
				returnSlotsCountOptional: 2,
			},
			status: 50,
			stopSale: false,
			markAsPopular: false,
			sumOfTransport: {
				reservations: {
					departureReservationCount: 8,
					departureReservationCountOptional: 1,
					returnReservationCount: 8,
					returnReservationCountOptional: 1,
				},
				slots: {
					departureSlotsCount: 16,
					departureSlotsCountOptional: 2,
					returnSlotsCount: 16,
					returnSlotsCountOptional: 2,
				},
			},
			swinging: false,
			termtourismeventSet: [
				{
					id: 1,
					crewCount: 7,
					eventId: 'g3aXrK234234234234234',
					kind: TermTourismEventSetKinds.BOTH,
					maxSeat: 1001,
				},
			],
			touristGuides: [],
			transportDeparture: { id: 1671, kind: 'OF', linkedTransport: null },
			transportReturn: { id: 1679, kind: 'OF', linkedTransport: null },
			transportStop: {
				address: 'Praga - Walentynki',
				erpGrid: [],
				id: 485,
				latitude: null,
				location: 3,
				longitude: null,
				parentStop: null,
				stopType: 'TG',
			},
		};
	}
}
